function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#121212",
  d: "M14.583 77.083l25-25L56.25 68.75l35.417-39.917-5.875-5.916L56.25 56.25 39.583 39.583l-31.25 31.25 6.25 6.25z"
});

function SvgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNC41ODM0IDc3LjA4MzRMMzkuNTgzNCA1Mi4wODM0TDU2LjI1IDY4Ljc1MDFMOTEuNjY2NyAyOC44MzM0TDg1Ljc5MTcgMjIuOTE2N0w1Ni4yNSA1Ni4yNTAxTDM5LjU4MzQgMzkuNTgzNEw4LjMzMzM3IDcwLjgzMzRMMTQuNTgzNCA3Ny4wODM0WiIgZmlsbD0iIzEyMTIxMiIvPgo8L3N2Zz4K";
export { SvgChart as ReactComponent };